import {ActionHandlerBase} from "../action-handler-base";
import {
    AdditionalActionName,
    AuthenticationServiceType,
    IAutoLoginActionPayLoad,
    ProductPackageToID
} from "@sparkware/uc-sdk-core";

export class AutologinActionHandler extends ActionHandlerBase<IAutoLoginActionPayLoad> {
    async handle(payload: IAutoLoginActionPayLoad): Promise<void> {

        if(payload.actionData.authenticationServiceType === AuthenticationServiceType.Registration) {
            this.services.sdk.eventsTrigger.registrationCompleted({
                UserInfo: payload.actionData.securityCode,
                SourceProductPackage: ProductPackageToID.REGISTRATION.toString()
            });
            await this.services.user.waitForAutoLogin();
            if(payload.actionData.additionalAction.name){
                this.services.analytics.registration.beginAdditionalAction(payload.actionData.additionalAction.name);
            }
        } else {
            await this.services.user.runAutoLogin({
                brandId: this.services.sdk.getBrandID(),
                token: payload.actionData.securityCode,
                sourceProductPackage: this.services.sdk.getProductPackageId(),
                sourceSubBrand: this.services.sdk.getSubBrandID()
            });
        }

        switch (payload.actionData.additionalAction.name) {
            case AdditionalActionName.openCashier:
                await this.services.cashier.openDeposit({
                    channel: payload.launchInfo?.channel,
                    launchInfo: payload.launchInfo,
                    PromCode: payload.actionData.additionalAction.properties?.promoCode
                });
                break;
            case AdditionalActionName.openIdentityVerification:
                await (await this.services.externalLinks).openUploadDocumentFromMyAccount();
                break;
        }
        if(payload.actionData.authenticationServiceType === AuthenticationServiceType.Registration &&
            payload.actionData.additionalAction.name){
            this.services.analytics.registration.endAdditionalAction(payload.actionData.additionalAction.name);
        }
    }
}